import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteKlausenLeopoldsdorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-klausenleopoldsdorf-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-klausenleopoldsdorf-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="klausen-Leopoldsdorf" />
      </div>
    </div>
  );
}

export default BodenfeuchteKlausenLeopoldsdorf;
